import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import {
  maxMobileScreenWidth,
  minDesktopScreenWidth
} from 'src/utils/breakpoints'
import { Search } from '@styled-icons/boxicons-regular'

export const ResponsiveContainer = styled.div`
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};
  width: 100vw;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    max-width: 480px;
    padding: 24px 24px;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    padding: 80px 80px 135px;
    max-width: 1440px;
    min-height: 100vh;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 8px;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    flex-direction: column;
  }
`

export const Title = styled.p`
  font-family: Rubik;
  font-style: normal;
  font-weight: bold;
  color: #2c3e51;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    font-size: 36px;
    line-height: 48px;
    padding-top: 80px;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    font-size: 48px;
    line-height: 48px;
  }
`

export const InputWrapper = styled.div`
  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    display: flex;
    align-items: center;
    padding: 8px 0;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    display: flex;
    align-items: center;
  }
`

export const Input = styled.input`
  width: 17.5rem;
  border-radius: 30px;
  height: 2rem;
  outline: none;
  border: none;
  background: #eef2f6;

  padding: 0.625rem 2.275rem;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    width: 100%;
    height: 100%;
  }
`

export const CareersWrapper = styled.ul`
  display: flex;
  width: 100%;
  list-style-type: none;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    flex-direction: column;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 50px;
  }
`

export const CareersWrapperItem = styled.li`
  display: flex;
  padding-top: 16px;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    width: 100%;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    width: 49%;
  }
`

export const LinkC = styled(LinkR)`
  display: flex;
  width: 100%;
  text-decoration: none;
`

export const JobNotFoundContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #eef2f6;
  margin-top: 24px;
`

export const JobNotFoundText = styled.div`
  width: 40%;
  padding: 32px 0;
  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    width: 100%;
  }
`

export const JobNotFoundP1 = styled.p`
  display: flex;
  justify-content: center;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 48px;
  color: rgba(0, 0, 0, 0.87);
  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    font-size: 18px;
    line-height: 21px;
    text-align: center;
  }
`

export const JobNotFoundP2 = styled.p`
  display: flex;
  justify-content: center;
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 48px;
  color: rgba(0, 0, 0, 0.87);
  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    padding-top: 12px;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
  }
`

export const SearchIcon = styled(Search)`
  color: #797979;
  position: absolute;
  padding: 0 10px;
`
